import { useEffect } from "react";
// SafeModal y no el Modal de reactstrap: este spinner se abre y cierra en milisegundos
// (y varios a la vez, uno por gráfico), justo el caso que dejaba la página sin scroll.
import Modal from "../safe-modal/SafeModal.jsx";

const Loading=(props) => {
    const {toggle, time, type, message}=props;
    return(
        
        <Modal isOpen={toggle} backdrop="static" contentClassName="bg-transparent"  centered={true}  size="xl ">
            <div className="d-flex align-self-center">
                <i className="fas fa-cog fa-spin fa-5x text-orange" role="status" />
            </div>
        </Modal>
        
    )
}

export default Loading;